import React from 'react';
import { withRouter } from 'react-router-dom';
import { navigateToUrl } from '../../utils/Navigating';
import './LeftToolbar.css';

class LeftToolBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {
    }

    navigate(url) {
        var urlObj = {
            pathname: url,
        };
        navigateToUrl(this.props, urlObj)
    }

    render() {
        var props = this.props;
        const userdata = JSON.parse(localStorage.getItem('kokos_userdata'))
        return (
            window.location.pathname !== "/" && <div className="Lefttoobar_main">
                {
                    (window.location.pathname === "/Schools" || window.location.pathname === "/AddUser" || window.location.pathname === "/") ?
                        <div>
                            <div className={window.location.pathname === "/Schools" ? "lefttoolbar_items_selected" : "lefttoolbar_items"} onClick={() => this.navigate("/Schools")}>Schools</div>
                            {
                                <div className={window.location.pathname === "/AddUser" ? "lefttoolbar_items_selected" : "lefttoolbar_items"} onClick={() => this.navigate("/AddUser")}>School Admins</div>
                            }
                        </div>
                        :
                       <div>
                            {userdata?.role_code !== 'STDADMN' ? <div className={window.location.pathname === "/Teachers" ? "lefttoolbar_items_selected" : "lefttoolbar_items"} onClick={() => this.navigate("/Teachers")}>Teachers</div> : <div></div>}
                            {userdata?.role_code !== 'STDADMN' ? <div className={window.location.pathname === "/SchoolClasses" ? "lefttoolbar_items_selected" : "lefttoolbar_items"} onClick={() => this.navigate("/SchoolClasses")}>Classes</div> : <div></div>}
                            <div className={window.location.pathname === "/Students" ? "lefttoolbar_items_selected" : "lefttoolbar_items"} onClick={() => this.navigate("/Students")}>Students</div>

                            {userdata?.role_code !== 'STDADMN' ? <div className={window.location.pathname === "/SchoolCourses" ? "lefttoolbar_items_selected" : "lefttoolbar_items"} onClick={() => this.navigate("/SchoolCourses")}>Courses</div> : <div></div>}

                            {userdata?.role_code !== 'STDADMN' ? <div className={window.location.pathname === "/Utilites" ? "lefttoolbar_items_selected" : "lefttoolbar_items"} onClick={() => this.navigate("/Utilites")}>Utilities</div> : <div></div>}
                        </div>
                }
            </div>
        );
    }
}


export default (withRouter(LeftToolBar));